import React from 'react';

function CloseIcon({
    onClick,
    className,
    color = 'black',
}) {
    return (
        <svg
            style={{ cursor: 'pointer' }}
            width='25'
            height='25'
            viewBox='0 0 25 25'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            onClick={onClick}
            className={className}
        >
            <path
                d='M12.5 1.5625C-1.95312 2.03125 -1.95312 22.9688 12.5 23.4375C26.9531 22.9688 26.9531 2.03125 12.5 1.5625ZM16.9531 15.7813C17.6563 16.4844 16.5625 17.5781 15.8594 16.875L12.5 13.5938L9.21875 16.875C8.51562 17.5781 7.42187 16.4844 8.125 15.7813L11.4062 12.5L8.125 9.21875C7.42187 8.51562 8.51562 7.42187 9.21875 8.125L12.5 11.4062L15.7813 8.125C16.4844 7.42187 17.5781 8.51562 16.875 9.21875L13.5938 12.5L16.9531 15.7813Z'
                fill={color}
            />
        </svg>
    );
}

export default CloseIcon;
